import React from "react";
import SitePage from "../SitePage";
import { Truck, PackageCheck, Clock, AlertCircle, MessageCircle } from "lucide-react";

const openChat = () => window.dispatchEvent(new CustomEvent("djk:open-chat"));

export default function SpedizioniPage() {
  return (
    <SitePage
      testId="spedizioni-page"
      breadcrumb="Help"
      breadcrumbLabel="Spedizioni"
      eyebrow="SPEDIZIONI / 配送"
      title="Come"
      accent="spediamo"
      subtitle="Ogni pacco parte da Viareggio, imballato a mano, tracciato dal primo all&apos;ultimo scan. Le tariffe definitive stanno per essere pubblicate — nel frattempo qui trovi come funziona il resto."
    >
      <div className="space-y-14 text-zinc-300 leading-relaxed">
        {/* Tariffe placeholder */}
        <div data-testid="spedizioni-tariffe" className="border-4 border-yellow-400 bg-yellow-400/5 p-6">
          <div className="flex items-start gap-4">
            <div className="bg-yellow-400 text-black p-2.5 shrink-0">
              <AlertCircle className="w-5 h-5" strokeWidth={3} />
            </div>
            <div>
              <div className="font-heading uppercase text-yellow-400 text-lg mb-2">Tariffe in aggiornamento</div>
              <p className="text-zinc-300 text-sm">
                Stiamo definendo i listini definitivi con i corrieri. Per un preventivo esatto sul tuo ordine, scrivici in chat: ti diamo il costo in pochi minuti prima che tu confermi.
              </p>
              <button data-testid="spedizioni-cta-chat" onClick={openChat} className="mt-4 inline-flex items-center gap-2 bg-black text-yellow-400 border-2 border-yellow-400 hover:bg-yellow-400 hover:text-black font-heading uppercase text-xs tracking-widest px-4 py-2 transition">
                <MessageCircle className="w-4 h-4" strokeWidth={3} /> Chiedi un preventivo
              </button>
            </div>
          </div>
        </div>

        {/* How we ship */}
        <div>
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-4">COME FUNZIONA</div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              { icon: Clock, title: "Elaborazione", text: "Entro 24-48 ore lavorative dal pagamento confermato. Se il pezzo è in vetrina, spesso parte in giornata." },
              { icon: Truck, title: "Trasporto", text: "Corriere espresso tracciato (SDA / BRT / Poste). Ricevi la lettera di vettura via email il giorno stesso della spedizione." },
              { icon: PackageCheck, title: "Consegna", text: "Ordini nazionali: consegna tipicamente in 2-4 giorni lavorativi. Estero UE: 5-9 giorni. Extra UE: solo su richiesta in chat." },
            ].map(({ icon: Icon, title, text }) => (
              <div key={title} className="bg-zinc-900/40 border-2 border-zinc-800 hover:border-yellow-400 p-5 transition">
                <div className="bg-yellow-400 text-black p-2 w-10 h-10 flex items-center justify-center mb-3">
                  <Icon className="w-5 h-5" strokeWidth={3} />
                </div>
                <div className="font-heading uppercase text-white text-lg mb-1">{title}</div>
                <p className="text-zinc-400 text-sm">{text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Imballo */}
        <div className="border-l-4 border-yellow-400 pl-6">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">IMBALLAGGIO</div>
          <h2 className="font-heading uppercase text-2xl text-white mb-3">Scatola in scatola</h2>
          <p>
            Le statue e le action figure numerate viaggiano sempre con doppio imballo:
            la scatola originale del produttore + una scatola di trasporto rinforzata con cellulosa da 60g.
            Se la confezione da collezione è danneggiata all&apos;arrivo, la rimborsiamo — anche se il pezzo è integro.
          </p>
        </div>

        {/* Ritiro in negozio */}
        <div className="border-l-4 border-yellow-400 pl-6">
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-3">RITIRO IN NEGOZIO</div>
          <h2 className="font-heading uppercase text-2xl text-white mb-3">Passa a prenderlo</h2>
          <p>
            Vuoi risparmiare la spedizione e vederlo dal vivo prima di portarlo a casa? Metti in nota &quot;Ritiro in negozio&quot; e ti scriviamo appena il pezzo è pronto in bottega.
            Viale Regina Margherita, 88 · Viareggio (LU) — dal lunedì al sabato, orari continuati sotto stagione estiva.
          </p>
        </div>
      </div>
    </SitePage>
  );
}
